module.exports = ".approved-task-row {\r\n    background-color: #d4f7d4;  /* Light green background */\r\n  }\r\n  "